import React from 'react'
import AddressSuggestionField from '../../formFields/addressSuggestionField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <AddressSuggestionField {...fieldProps} />
))
